// ! Temporal rule. Remove when the module is ready.
// Disable eslint rule for no-unused-vars
/* eslint-disable no-unused-vars */

import React, { useEffect, useState, useMemo, useRef } from 'react';
import _ from 'lodash';
import { FilterQueryParams, downloadReport } from '../../../../helpers';
import { Card, CardBody, HeaderTitle, MenuSVG, MovementsSVG, Table } from '../../../../components';
import { useMovementsUIContext } from '../context/MovementsUIContext';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import movementsColumns from './MovementsColumns';
import RechargeModal from '../modal/RechargeModal';
import DownloadModal from '../modal/DownloadModal';
import MovementsDetail from '../modal/MovementDetail';
import { usersService } from '../../../../services';
import page from '../../../../constants/pages/page';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MovementsCustomFilters from './filters/MovementsCustomFilters';
import { palette } from '../../../../styles/theme';

export default function MovementsTable () {
    // sortKeyMap
    const { t } = useTranslation();
    const customSortedKeyMap = { created_at_time: 'created_at' };
    const { sortedKeyMap, defaultSorted } = UIHelpers(customSortedKeyMap);

    const movementsFiltersRef = useRef();

    // Context state

    const movementsUIContext = useMovementsUIContext();
    const movementsUIProps = useMemo(() => {
        return {
            isLoading: movementsUIContext.isLoading,
            setIsLoading: movementsUIContext.setIsLoading,
            queryParams: movementsUIContext.queryParams,
            setQueryParams: movementsUIContext.setQueryParams
        };
    }, [movementsUIContext]);

    // List state
    const [movementsList, setMovementsList] = useState();
    const [totalMovements, setTotalMovements] = useState(0);
    const [percents, setPercents] = useState(1);

    // Modal state

    const [openRechargeModal, setOpenRechargeModal] = useState(false);
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const [rechargeShow, setRechargeShow] = useState({});

    // Transaction detail state

    const [openDetail, setOpenDetail] = useState(false);

    // Functions

    async function fetchMovements (download, page) {
        // change state isLoading
        movementsUIProps.setIsLoading(true);

        // Prepare options (order, pages and filters)
        const filters = movementsUIProps.queryParams.filters || new FilterQueryParams();
        const { sortField, sortOrder } = movementsUIProps.queryParams;
        const options = {
            order: `${sortedKeyMap[sortField] || sortField}-${sortOrder.toUpperCase()}`,
            pageSize: download || movementsUIProps.queryParams.pageSize,
            page: page || movementsUIProps.queryParams.pageNumber,
            view: 'movements'
        };

        // Set filters on options.
        options.filters = filters.build();
        await usersService.getUsersCreditCards(options)
            .then(movements => {
                setMovementsList(movements);
            })
            .catch(e => {
                console.error(e);
                return [];
            })
            .finally(() => {
                movementsUIProps.setIsLoading(prevValue => !prevValue);
            });
    };

    const getTotalMovements = async () => {
        movementsUIProps.setIsLoading(true);
        const filters = movementsUIProps.queryParams.filters || new FilterQueryParams();
        const options = {
            unionPeople: true,
            pageSize: 100000,
            view: 'movements'
        };
        options.filters = filters.build();
        await usersService.getUsersCreditCards(options)
            .then(movements => {
                setTotalMovements(movements.length);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                movementsUIProps.setIsLoading(prevValue => !prevValue);
            });
    };

    const getData = async () => {
        await getTotalMovements();
        fetchMovements();
    };

    // Handle Modal
    const handleCloseModal = () => {
        setOpenRechargeModal(false);
        setOpenDetail(false);
    };

    const handleTransactionDetail = transfer => {
        setOpenDetail(true);
        setSelectedTransaction(transfer);
    };

    const download = () => {
        downloadReport(movementsUIContext);
    };

    const resetFilters = () => {
        if (movementsFiltersRef.current) {
            movementsFiltersRef.current.reset();
        }
    };

    useEffect(() => {
        movementsUIProps.setQueryParams(prev => ({ ...prev, pageSize: localStorage.getItem('sizePerPage') || page.pageSize }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (JSON.stringify(movementsUIProps.queryParams.url) !== undefined) {
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [movementsUIProps.queryParams]);

    // Main Component
    return (
        <>
            <RechargeModal
                open={openRechargeModal}
                onClose={handleCloseModal}
                recharge={rechargeShow}
                transaction={selectedTransaction}
            />
            <DownloadModal
                open={openDownloadModal}
                percents={percents}
            />
            {openDetail && (
                <MovementsDetail
                    open={openDetail}
                    onClose={handleCloseModal}
                    transfer={selectedTransaction}
                />
            )}

            <Card>
                <Box >
                    <HeaderTitle
                        title={t('activity.table.title')}
                        total={totalMovements}
                        download={download}
                        reset={resetFilters}
                        icon={(<MovementsSVG customStroke={palette.primary[700]} className='mr-1 mb-2' />)}
                        UIProps={movementsUIProps}
                    />
                    <MovementsCustomFilters
                        ref={movementsFiltersRef}
                    />
                </Box>
                <CardBody>
                    <Table
                        data={movementsList}
                        columns={movementsColumns({ handleTransactionDetail })}
                        sort={defaultSorted}
                        onChange={movementsUIProps.setQueryParams}
                        isLoading={movementsUIProps.isLoading}
                        total={totalMovements}
                        pagination={{
                            sizePerPage: movementsUIProps.queryParams.pageSize,
                            page: movementsUIProps.queryParams.pageNumber
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
};
